<template>
  <b-overlay :show="mapLoading" bg-color="transparent" blur="2px">
    <template #overlay>
      <div v-if="mapLoading" class="text-center py-3">
        <img src="@/assets/lottie/plant.gif" alt="Loading..." style="width: 40px;" />
      </div>
    </template>

    <b-card no-body class="rounded-xl mb-5">
      <b-card-header
        class="border-2 border-bottom px-5 pt-0 pb-3"
        v-if="title"
      >
        <h3>{{ title }}</h3>
      </b-card-header>

      <b-card-body class="p-0">
        <div
          class="map-wrapper"
          style="height: 400px; width: 100%; position: relative;"
        >
          <template v-if="!isMapLoaded">
            <div
              class="d-flex align-items-center justify-content-center"
              style="
                height: 100%;
                width: 100%;
                background: rgba(0,0,0,0.2);
                border-radius: 10px;
              "
            >
              <div
                class="buka-map-btn text-center py-3 px-4 bg-light text-primary rounded shadow-sm"
                style="cursor: pointer;"
                @click="loadMap"
              >
                Buka Maps
              </div>
            </div>
          </template>

          <div
            v-else
            ref="mapContainer"
            style="height: 100%; width: 100%; border-radius: 10px;"
          ></div>
        </div>
      </b-card-body>
    </b-card>
  </b-overlay>
</template>

<script>
export default {
  name: "multi-coordinate-loader",

  props: {
    title: {
      type: String,
      default: null,
    },

    coordinates_data: {
      type: Array,
      default() {
        return [];
      },
    },
  },

  data() {
    return {
      mapLoading: false,
      isMapLoaded: false,
      maps: null,
      markers: [],
    };
  },

  methods: {
    async loadMap() {
      this.mapLoading = true;
      this.isMapLoaded = true;

      await this.$nextTick();
      await this.initializeMap();

      this.mapLoading = false;
    },

    async initializeMap() {
      let center = [110.414672, -7.024947];

      if (this.coordinates_data.length > 0) {
        const first = this.coordinates_data[0];

        center = [
          Number(first.longitude),
          Number(first.latitude),
        ];
      }

      this.maps = new mapboxgl.Map({
        accessToken: this.$_config.apikey.mapbox,
        container: this.$refs.mapContainer,
        style: "mapbox://styles/mapbox/satellite-streets-v12",
        center,
        zoom: 10,
        projection: "globe",
      });

      this.maps.addControl(new mapboxgl.NavigationControl());
      this.maps.addControl(new mapboxgl.FullscreenControl());

      this.maps.on("load", () => {
        this.loadMarkers();
      });
    },

    loadMarkers() {
      if (!this.coordinates_data.length) {
        return;
      }

      const bounds = new mapboxgl.LngLatBounds();

      this.coordinates_data.forEach((item, index) => {
        const latitude = Number(item.latitude);
        const longitude = Number(item.longitude);

        if (
          isNaN(latitude) ||
          isNaN(longitude)
        ) {
          console.warn("Invalid coordinate:", item);
          return;
        }

        const popup = new mapboxgl.Popup({
          offset: 25,
        }).setHTML(`
          <div>
            <strong>${item.label || ("Coordinate " + (index + 1))}</strong>
            <br>
            Lat: ${latitude}
            <br>
            Lng: ${longitude}
          </div>
        `);

        const marker = new mapboxgl.Marker({
          color: item.color || "#ff0000",
        })
          .setLngLat([longitude, latitude])
          .setPopup(popup)
          .addTo(this.maps);

        this.markers.push(marker);

        bounds.extend([longitude, latitude]);
      });

      if (!bounds.isEmpty()) {
        this.maps.fitBounds(bounds, {
          padding: 50,
          maxZoom: 16,
        });
      }
    },
  },

  beforeDestroy() {
    if (this.maps) {
      this.maps.remove();
    }
  },
};
</script>

<style scoped>
.map-wrapper {
  border-radius: 10px;
  overflow: hidden;
}

.buka-map-btn {
  transition: all 0.2s ease;
}

.buka-map-btn:hover {
  transform: translateY(-1px);
}
</style>


// WEBPACK FOOTER //
// src/base/component/multi-coordinate-loader.vue